var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletRedeemSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 122,
    viewBox: "0 0 139 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 98.0791,
    y: 3.88477,
    width: 5.71703,
    height: 5.71703,
    transform: "rotate(132.808 98.0791 3.88477)",
    fill: "#FCC332"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 125.121,
    y: 94,
    width: 3.14732,
    height: 3.14732,
    transform: "rotate(82.6043 125.121 94)",
    fill: "#FCC332"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5498,
    y: 18.0498,
    width: 4.62066,
    height: 4.62066,
    transform: "rotate(103.132 56.5498 18.0498)",
    fill: "#FCC332"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5498,
    y: 96.0493,
    width: 4.62066,
    height: 4.62066,
    transform: "rotate(103.132 24.5498 96.0493)",
    fill: "#466DFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 138.55,
    y: 85.0503,
    width: 4.62066,
    height: 4.62066,
    transform: "rotate(103.132 138.55 85.0503)",
    fill: "#FCC332"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5498,
    y: 75.0498,
    width: 4.62066,
    height: 4.62066,
    transform: "rotate(103.132 5.5498 75.0498)",
    fill: "#FCC332"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 122.48,
    y: 38.605,
    width: 7.06128,
    height: 7.06128,
    transform: "rotate(103.132 122.48 38.605)",
    fill: "#8AFCFD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 131.112,
    y: 66.7241,
    width: 7.5871,
    height: 7.5871,
    transform: "rotate(103.132 131.112 66.7241)",
    fill: "#466DFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5771,
    y: 32,
    width: 7.5871,
    height: 7.5871,
    transform: "rotate(28.1317 62.5771 32)",
    fill: "#466DFF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 87.0498,
    y: 22.2061,
    width: 7.20004,
    height: 7.20004,
    transform: "rotate(125.744 87.0498 22.2061)",
    fill: "#D95EDC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 6.52469,
    height: 6.52469,
    transform: "matrix(-0.249696 -0.968324 -0.968324 0.249696 138.829 105.617)",
    fill: "#D95EDC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9209,
    y: 47.7612,
    width: 7.20004,
    height: 7.20004,
    transform: "rotate(96.0679 16.9209 47.7612)",
    fill: "#D95EDC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1689,
    y: 32.4004,
    width: 4.38493,
    height: 4.38493,
    transform: "rotate(140.849 46.1689 32.4004)",
    fill: "#D95EDC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 30.6855,
    width: 8.77519,
    height: 8.77519,
    transform: "rotate(-11.0719 93 30.6855)",
    fill: "#8AFCFD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 67.6846,
    width: 8.77519,
    height: 8.77519,
    transform: "rotate(-11.0719 15 67.6846)",
    fill: "#8AFCFD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 52.0005,
    width: 71,
    height: 69,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5566 103V73.1411H64.7216L64.6601 95.4126L53.0732 73.1411H49.2177V103H53.0527L53.1142 80.688L64.7011 103H68.5566ZM81.5674 89.814V86.5942H69.1396V76.3813H83.6387V73.1411H65.3047V103H69.1396V89.814H81.5674ZM100.197 76.3813V73.1411H78.0489V76.3813H87.2774V103H90.9688V76.3813H100.197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletRedeemSuccess);
export default __webpack_public_path__ + "static/media/wallet-redeem-success.143cc62ab148752d38f3abdd04e7f52a.svg";
export { ForwardRef as ReactComponent };